import FunctionContainer from "../FunctionContainer";
import FunctionMain from "../FunctionMain";
import FunctionPanel from "../FunctionPanel";

function FunctionStructure({ id }) {
  return (
    <FunctionContainer id={id}>
      <FunctionPanel id={id} />
      <FunctionMain id={id} />
    </FunctionContainer>
  );
}

export default FunctionStructure;
